import { defineStore } from "pinia";
import type { FeatureFlagDetail } from "posthog-js";
import { computed, ref } from "vue";

export const useFeatureFlagStore = defineStore("featureFlag", () => {
	const featureFlags = ref<Record<string, FeatureFlagDetail>>({});

	function get(featureName: string, throwOnMissing = false) {
		return computed(() => {
			const feature = featureFlags.value[featureName.toLowerCase()];

			if (feature === undefined) {
				if (throwOnMissing) {
					throw new Error(`Unknown feature flag: "${featureName}"`);
				}

				return false;
			}

			if (typeof feature === "boolean") {
				return feature;
			}

			return feature.enabled;
		});
	}

	function $reset(features: Record<string, FeatureFlagDetail> | null = null) {
		if (features === null) {
			featureFlags.value = {};
		} else {
			featureFlags.value = features;
		}
	}

	$reset();

	return { get, $reset };
});
